<template>
  <div class="rn-masonary-wrapper">
    <h2 class="heading-title mb-10 text-center">{{ title }}</h2>
    <div class="wrapper plr--70 plr_sm--30 plr_md--30">
      <div class="be-custom-gallery">
        <div>
          <v-tabs v-model="tab" centered flat hide-slider color="primary">
            <v-tab :ripple="false" v-for="item in tabItems" :key="item.id">{{
                item.name
              }}</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in tabContent" :key="item.id">
              <CoolLightBox
                  :items="item.content"
                  :index="index"
                  :fullScreen="true"
                  :effect="'fade'"
                  @close="index = null"
              >
              </CoolLightBox>
              <div
                  class="gallery-wrapper gallery-grid mesonry-list grid-metro3"
                  id="animated-thumbnials"
              >
                <div
                    v-for="(item, i) in item.content"
                    :key="i"
                    @click="index = i"
                    class="image masonry_item portfolio-33-33"
                >
                  <div class="item-portfolio-static ">
                    <div class="portfolio-static">
                      <div class="thumbnail-inner">
                        <div class="thumbnail">
                          <img :src="item.thumb" alt="portfolio image" />
                        </div>
                      </div>

                      <div class="content">
                        <div class="inner">
                          <p>{{ item.tag }}</p>
                          <h4>{{ item.title }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {container} from "@/main";
import {HomeService} from "@/pages/home/home.service";

export default {
  async created() {
    this.homeService = container.get(HomeService);
    const pageData = await this.homeService.getWorksPage();
    // Crear una instancia de DOMParser
    var parser = new DOMParser();
    // Usar parseFromString para convertir la cadena HTML en un documento HTML
    const doc = parser.parseFromString(pageData.content.rendered, 'text/html');
    const acordeons = doc.querySelectorAll('.wp-block-coblocks-accordion-item');
    const dataAccordion = Array.from(acordeons).map(acordeon => {
      const title = acordeon.querySelector('summary').textContent.trim();
      const tag = acordeon.querySelector('summary').textContent.trim();
      const images = Array.from(acordeon.querySelectorAll('img')).map(img => img.src);
      return { title, images, tag };
    });
    this.title = pageData.title.rendered;
    this.tabContent = [];
    this.tabItems = [];
    for(const index in dataAccordion) {
      const data = dataAccordion[index];
      const images = data.images;
      const title = data.title;
      const tag = data.tag;
      this.tabItems[index] = {
        id: index,
        name: title,
      };
      this.tabContent.push({
        id: index,
        content: images.map((image) => {
          return {
            thumb: image,
            src: image,
            tag: tag,
            title: title,
          }
        })
      });
    }
    // Eliminar la categoría "Todos"
    const allIndex = this.tabItems.findIndex(item => item.name === 'Todos');
    if (allIndex !== -1) {
      this.tabItems.splice(allIndex, 1);
      this.tabContent.splice(allIndex, 1);
    }

    // Crear una nueva categoría que agrupe todas las categorías consecutivas
    const groupedCategory = 'Todo';

    // Obtener todas las imágenes de todas las categorías
    const allImages = [].concat(...this.tabContent.map(tab => tab.content));

    // Crear un nuevo tabContent para la categoría agrupada
    const groupedTabContent = {
      id: 'grouped',
      content: allImages,
    };

    // Agregar el nuevo tabContent a la primera posición
    this.tabContent.unshift(groupedTabContent);

    // Agregar la nueva categoría al principio de tabItems
    this.tabItems.unshift({
      id: 'grouped',
      name: groupedCategory,
    });
  },
  data() {
    return {
      tab: null,
      index: null,
      title: null,
      tabItems: [],
      tabContent: [],
    };
  },
};
</script>
